import React, { useEffect, useState } from "react";
import axios from "axios";
import "../admin.css";
import { NavLink } from "react-router-dom";

const CityList = () => {
  let [loggedinuser] = useState(JSON.parse(localStorage.getItem("user")));
  const [citys, setCitys] = useState([]);
  const [pages, setPages] = useState({ page: 1, size: 1000 });
  const [paging, setPaging] = useState(true);

  const filterFunction = () => {
    // Declare variables
    var input, filter, table, tr, td, td1, i, txtValue;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("myTable");
    tr = table.getElementsByTagName("tr");

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      td1 = tr[i].getElementsByTagName("td")[1];
      if (td || td1) {
        txtValue =
          (td.textContent || td.innerText) + (td1.textContent || td1.innerText);

        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  };

  const nextPage = () => {
    loadPaging(pages.page + 1, pages.size);
    setPages((prevState) => {
      return {
        ...prevState,
        page: prevState.page + 1,
      };
    });
  };

  const loadPaging = async (page, size = pages.size) => {
    try {
      await axios
        .get(
          localStorage.getItem("basurl") +
            "/getcities?page=" +
            page +
            "&size=" +
            size,
          {
            headers: {
              "mojo-access-tokens": loggedinuser.token,
            },
          }
        )
        .then((response) => {
          setCitys((prevState) => {
            prevState.push.apply(prevState, response.data);
            return [...prevState];
          });
          if (response.data.length < size) {
            setPaging(false);
          }
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("city");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadPaging(1);
  }, []);

  return (
    <>
      <input
        type="text"
        id="myInput"
        onKeyUp={filterFunction}
        placeholder="Search for cities.."
      ></input>
      {citys.length ? (
        <table id="myTable" className="table table-striped table-hover">
          <thead>
            <tr>
              <th>State</th>
              <th>City</th>
              <th>Active</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {citys.map((item) => (
              <tr key={item.id}>
                <td>
                  {item.statename} ({item.shortname})
                </td>
                <td>{item.cityname}</td>
                <td>
                  <input type="checkbox" disabled checked={item.status} />
                </td>

                <td>
                  <NavLink
                    to={`/masters/update-city/${item.id}`}
                    className="mg-l-10"
                  >
                    Edit
                  </NavLink>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="media pd-20 pd-xs-30">
          <span className="tx-center">You have not added any city yet.</span>
        </div>
      )}
      <div className="card-footer tx-10 pd-y-15 bg-transparent tx-center">
        {paging ? (
          <h4 onClick={nextPage} href="#" className="pointer tx-16">
            <i className="fa fa-angle-down mg-r-5" />
            View More
          </h4>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default CityList;
